import { ReactNode } from "react";

import { Icon } from "~/assets/icons/Icon";

import styles from "./AchievedMetric.module.scss";

interface Props {
  /** The optimised value to show, e.g. "100%" or the Fully Visible badge. */
  value?: ReactNode;
  /** Optional numeric improvement; renders "↑92%". Omitted shows a bare ↑. */
  gain?: number;
  /** Optional details tooltip shown on hover. */
  tooltip?: string;
}

const AchievedMetric = ({ value, gain, tooltip }: Props) => (
  <span
    className={styles.wrap}
    style={tooltip ? { cursor: "help" } : undefined}
    data-tooltip-id={tooltip ? "vm-header-tooltip" : undefined}
    data-tooltip-content={tooltip}
  >
    {value != null && <span className={styles.value}>{value}</span>}
    <span className={styles.badge}>
      <Icon iconName="PercentUpIcon" width="0.9rem" height="0.9rem" />
      {gain != null && `${gain}%`}
    </span>
  </span>
);

export default AchievedMetric;
